"use strict";
exports.__esModule = true;
exports.StepFunctionName = void 0;
var StepFunctionName;
(function (StepFunctionName) {
    StepFunctionName["bookPushedDeposit"] = "bookPushedDeposit";
    StepFunctionName["dailySecuritiesUpdate"] = "dailySecuritiesUpdate";
    StepFunctionName["exportPositions"] = "exportPositions";
    StepFunctionName["ingestDistributionDeclarations"] = "ingestDistributionDeclarations";
    StepFunctionName["ingestFundRules"] = "ingestFundRules";
    StepFunctionName["ingestPrices"] = "ingestPrices";
    StepFunctionName["ingestDivAccrualRates"] = "ingestDivAccrualRates";
    StepFunctionName["investContribution"] = "investContribution";
    StepFunctionName["newPlan"] = "newPlan";
    StepFunctionName["processInbound"] = "processInbound";
    StepFunctionName["processOutbound"] = "processOutbound";
    StepFunctionName["reconParentToCustBalancesOrchestrator"] = "reconParentToCustBalancesOrchestrator";
    StepFunctionName["reconParentToCustPositionsOrchestrator"] = "reconParentToCustPositionsOrchestrator";
    StepFunctionName["reconParentToSubsBalancesOrchestrator"] = "reconParentToSubsBalancesOrchestrator";
    StepFunctionName["reconParentToSubsPositionsOrchestrator"] = "reconParentToSubsPositionsOrchestrator";
    StepFunctionName["reconCustodianFundActivityOrchestrator"] = "reconCustodianFundActivityOrchestrator";
    StepFunctionName["tradeRequest"] = "tradeRequest";
    StepFunctionName["transferInbound"] = "transferInbound";
    StepFunctionName["ingestCustodianFundInformation"] = "ingestCustodianFundInformation";
    StepFunctionName["determineActiveDividendPayments"] = "determineActiveDividendPayments";
    StepFunctionName["dividendCalculator"] = "dividendCalculator";
    StepFunctionName["flattenRequest"] = "flattenRequest";
    StepFunctionName["queueReversalByTracerId"] = "queueReversalByTracerId";
    StepFunctionName["queueReversalBySourceTransactionId"] = "queueReversalBySourceTransactionId";
    StepFunctionName["queueReversalByOrderId"] = "queueReversalByOrderId";
    StepFunctionName["queueIndividualSubAccountOrder"] = "queueIndividualSubAccountOrder";
    StepFunctionName["distribution"] = "distribution";
    StepFunctionName["accountPerformanceOrchestrator"] = "accountPerformanceOrchestrator";
    StepFunctionName["dividendActivityOrchestrator"] = "dividendActivityOrchestrator";
    StepFunctionName["holdingTankSubAccountOrchestrator"] = "holdingTankSubAccountOrchestrator";
    StepFunctionName["orderAggregationOrchestrator"] = "orderAggregationOrchestrator";
    StepFunctionName["orderDeaggregationOrchestrator"] = "orderDeaggregationOrchestrator";
    StepFunctionName["historicalDividendProcessOrchestrator"] = "historicalDividendProcessOrchestrator";
    StepFunctionName["feeTransferOrchestrator"] = "feeTransferOrchestrator";
    StepFunctionName["advancedCorrectionsOrchestrator"] = "advancedCorrectionsOrchestrator";
    StepFunctionName["feeAllocationOrchestrator"] = "feeAllocationOrchestrator";
    StepFunctionName["refreshReconsOrchestrator"] = "refreshReconsOrchestrator";
    StepFunctionName["cashInterestActivityOrchestrator"] = "cashInterestActivityOrchestrator";
    StepFunctionName["processInboundOrchestrator"] = "processInboundOrchestrator";
    StepFunctionName["routeInboundOrchestrator"] = "routeInboundOrchestrator";
    StepFunctionName["alertAutoCloserOrchestrator"] = "alertAutoCloserOrchestrator";
    StepFunctionName["fundMergeOrchestrator"] = "fundMergeOrchestrator";
    StepFunctionName["marketValueAdjustmentOrchestrator"] = "marketValueAdjustmentOrchestrator";
})(StepFunctionName = exports.StepFunctionName || (exports.StepFunctionName = {}));
